import { gql, TypedDocumentNode } from "@apollo/client";

import { AiModel, QueryAvailableAiModelsArgs } from "types/generated";

type AvailableAiModelView = Pick<AiModel, "id" | "name">;

type AvailableAiModelsData = {
  availableAIModels: AvailableAiModelView[];
};

export const AVAILABLE_AI_MODELS: TypedDocumentNode<
  AvailableAiModelsData,
  QueryAvailableAiModelsArgs
> = gql`
  query AvailableAIModels($provider: String!, $apiKey: String, $baseURL: String, $space: ID) {
    availableAIModels(provider: $provider, apiKey: $apiKey, baseURL: $baseURL, space: $space) {
      id
      name
    }
  }
`;
